<template>
  <div>
    <template v-if="!disabled">
      <el-cascader
        :options="nodeList"
        v-model="defaultValue"
        :props="{ expandTrigger: 'hover', multiple: true}"
        :show-all-levels="false"
        :append-to-body="false"
        @change="batchClassChange"
        class="input-new-tag"
        ref="saveTagInput"
        placeholder="试试搜索：分类"
        filterable
        :filter-method="dataFilter"
      ></el-cascader>
    </template>
  </div>
</template>

<script>
import { classListApi } from '@/api/resource';
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    addBeforeFun: {
      type: Function
    },
      maxSelected: {
        type: Number,
          default: 0 // 0 means no limit
      }
  },
  data() {
    return {
      defaultValue: [],
      dynamicTags: [],
      inputVisible: false,
      /* 类型：0:模型，1:父子模型 */
      nodeList : [
        { value: '0_1', label: '模型类型', leaf: false, checked: true, type: 0, children:[] },
        { value: '1_1', label: '模型类别', leaf: false, type: 1, children:[] }
      ],
      nodeListAll:[]
    };
  },
  created() {
    this.nodeList.forEach(node =>{
      let params = {type:node.type,parentId:node.value.split('_')[1]};
      classListApi(params).then(async res => {
        if (res.code === 200) {
          let nodeList = []
          if (node.type == 0) {
            nodeList = res.data.map(item => {
              return {
                type:0,
                value: `0_${item.categoryId}`,
                label: item.categoryName,
              }
            })
            node.children = nodeList;
            this.nodeListAll = this.nodeListAll.concat(nodeList);
          } else {
            this.recursionQueryTree(node,res.data)
          }
        }
      })
    })
  },
  methods: {
    recursionQueryTree(node,data){
      let nodeList = data.map(item => {
        return {
          type:0,
          value: `0_${item.categoryId}`,
          label: item.categoryName,
          children:item.menuCategoryList.length>0?item.menuCategoryList:undefined,
        }
      })
      node.children = nodeList;
      this.nodeListAll = this.nodeListAll.concat(nodeList);
      node.children.forEach(item =>{
        if(item.children){
          this.recursionQueryTree(item,item.children);
        }
      })
    },
    setTags(arr) {
      this.dynamicTags = arr;
    },
    addSelectedValue(value) {
      this.defaultValue.push(value);
    },

    batchClassChange(changedValue) {
        const MAX_SIZE = this.maxSelected;
        if(MAX_SIZE != 0) {
            let new_value;
            if (changedValue.length > MAX_SIZE) {
                let diff_size = changedValue.length - MAX_SIZE;
                let arrayString = this._defaultValue.map(o => o.join(','));

                let d_array = changedValue.filter( o=> (arrayString.indexOf(o.join(',')) < 0))

                let itemToBeDelete = d_array.reverse().splice(0, diff_size);
                let itemToBeHead = d_array.slice();


                new_value = changedValue.slice();
                let remove_index = [];
                itemToBeDelete.map(delete_node => {
                    for(let j = 0;j<new_value.length;j++) {
                        let value = new_value[j];
                        if (value.join(',') === delete_node.join(',')) {
                            remove_index.push(j);
                            break;
                        }
                    }
                });

                let sorted_remove_index = remove_index.sort(function(a,b) {return b-a})

                sorted_remove_index.map(value => {
                    new_value.splice(value, 1);
                });


              let valueToBeHeadArray = [];
              itemToBeHead.map(valueToBeHead => {
                for(let j = 0;j<new_value.length; j++) {
                  let value = new_value[j];
                  if (value.join(',') === valueToBeHead.join(',')) {
                    valueToBeHeadArray.push(valueToBeHead);
                    new_value.splice(j,1)
                    break;
                  }
                }
              });

                new_value = valueToBeHeadArray.concat(new_value);



                // this.$message(`当前只允许选择${MAX_SIZE}个选项`)
                // new_value = changedValue.slice(0, MAX_SIZE);
                changedValue = new_value;
                this.defaultValue = new_value.slice();

            }
        }
        // cache current defaultValue
        /*
         in case of cutting last insert values , we need to cache current value to be compare with new value which will pass on next change;
         */
        this._defaultValue = JSON.parse(JSON.stringify(this.defaultValue));
        window._defaultvalue = this._defaultValue;

      this._newDynamicTags = [];
      changedValue.map(value => {
        this.classChange(value)
      })
      this.dynamicTags = this._newDynamicTags;
      this.$emit('callback', [...this.dynamicTags]);
    },

    classChange(changeValue) {
      // console.log(changeValue)
      // console.log(changeValue[changeValue.length-1])
      if (changeValue) {
        //const [node = {}] = this.$refs.saveTagInput.getCheckedNodes() || [];
        const [_, categoryId] = changeValue[changeValue.length-1].split('_');
        const label  = this.nodeListAll.find(inner => inner.value == changeValue[changeValue.length-1]).label;
        // const index = this.dynamicTags.findIndex(inner => inner.categoryId == categoryId);

        this._newDynamicTags.push({
          categoryId,
          categoryName: label
        })

        // if (index > -1) {
        //   this.$message.error("分类已存在");
        //   this.inputVisible = false;
        //   return false;
        // }
        //
        // this.dynamicTags.push({
        //   categoryId,
        //   categoryName: label,
        // });
        // this.$emit('callback', [...this.dynamicTags]);
        // this.inputVisible = false;
      }
    },
    handleClose(tag) {
      this.dynamicTags = this.dynamicTags.filter(item => {
        return item.categoryId != tag.categoryId
      });

      this.$emit('callback', [...this.dynamicTags]);
    },
    showInput() {
      if (this.addBeforeFun) {
        let flag = this.addBeforeFun(this.dynamicTags);
        if (!flag) {
          return false;
        }
      }
      this.inputVisible = true;
    },
    dataFilter(node, val) {
      if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
        return true
      }
    },
  },

  computed: {
      wat: function() {
        let new_arr = this.defaultValue.slice();
        let result_arr = [];
        for (let i = 0; i < new_arr.length; i++) {
          result_arr.push(new_arr[i].join(','))
        }

        return result_arr;
      }
},

    watch: {
      defaultValue: function(cur) {

          let selectedValuesString = [];
          cur.map(item => {
              selectedValuesString.push(item.join(','));
          })
          let that = this;
          function processChildren(children, parentValues) {
              children.map(child => {
                  if(child.hasOwnProperty('children') && Array.isArray(child.children)) {
                      processChildren(child.children, parentValues.concat([child.value]))
                  }

                  let currentValue = child.value;
                  let values = parentValues.concat(currentValue);
                  let valuesString = values.join(',');
                  if(selectedValuesString.indexOf(valuesString) > -1) {
                      // 当前选中状态, 始终为可选状态
                      that.$set(child, 'disabled', false)
                      return ;
                  }  else {
                      // 循环判断是否为父级别

                      for(let i =0;i<selectedValuesString.length;i++) {
                          if(selectedValuesString[i].indexOf(valuesString) > -1) {
                              that.$set(child, 'disabled', false)
                              return ;
                          }
                      }
                  }

                      if(selectedValuesString.length < that.maxSelected && that.maxSelected != 0) {
                          that.$set(child, 'disabled', false)
                      } else {
                          that.$set(child, 'disabled', true)
                      }

              })
          }

          this.nodeList.map(item => {
              if(item.hasOwnProperty('children') && Array.isArray(item.children)) {
                  processChildren(item.children, [item.value])
              }
          })
      }
    }
}
</script>

<style scoped>
.el-tag + .el-tag {
  margin-right: 10px;
}
.button-new-tag {
  margin-right: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 550px;
  margin-right: 10px;
  vertical-align: bottom;
}

.el-cascader-panel .el-scrollbar:first-child .el-checkbox {
  display: none!important;
}
</style>
